<footer class="footer mt-auto px-4 py-4 text-white inset-shadow-xs">
  <div class="container mx-auto">
    <div class="text-center">
      <p>
        &copy; {{ currentYear }} SageWrite ehf. All rights reserved | Grettisgata 55, 101 Reykjavík,
        Iceland
      </p>
    </div>
  </div>
</footer>
